module.exports = __webpack_public_path__ + "img/pic_312592_1.8d8ddc2e.jpg";